"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointCollectionCache = exports.IkeTransformer = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var store_1 = require("../../store");
var IkeTransformer = /** @class */ (function () {
    function IkeTransformer() {
    }
    /**
     * Create a caching function to remember the result  of the transformer,
     * This will be automatically updated if any observables change inside the transformer.
     */
    IkeTransformer.create = function (transformer, opts) {
        var views = {};
        function createView(source) {
            var transformerName = "Transformer-".concat(opts.name, "-").concat(source);
            var expr = (0, mobx_1.computed)(function () { return transformer(source); }, { name: transformerName });
            var disposer = (0, mobx_1.onBecomeUnobserved)(expr, function () {
                disposer();
                delete views[source];
            });
            return expr;
        }
        return function (obj) {
            var existing = views[obj];
            if (existing == null) {
                existing = views[obj] = createView(obj);
            }
            return existing.get();
        };
    };
    return IkeTransformer;
}());
exports.IkeTransformer = IkeTransformer;
var PointCollectionCache = /** @class */ (function () {
    function PointCollectionCache() {
    }
    /** Get a list of collection vectors given the collection revision */
    PointCollectionCache.getCollectionVectors = IkeTransformer.create(function (revision) {
        var collection = store_1.AppStore.Collection.get(revision);
        if (collection == null) {
            return null;
        }
        var output = [];
        collection.forEachField(function (field) {
            if (field.value == null) {
                return;
            }
            var collectionLocation = PointCollectionCache.getCollectionLocation(revision);
            if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
                var _a = field.value, distance = _a.distance, bearing = _a.bearing;
                var target = core_shared_1.IkeGeodesic.projectLocation(collectionLocation, bearing, distance);
                output.push({ field: field, target: target });
            }
            if (core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) {
                var _b = field.distanceBearingPitch(collectionLocation), distance = _b.distance, bearing = _b.bearing;
                var target = core_shared_1.IkeGeodesic.projectLocation(collectionLocation, bearing, distance);
                output.push({ field: field, target: target });
            }
        });
        return output;
    }, { name: 'getCollectionVectors' });
    /** Location is hard to find, so cache the location lookups */
    PointCollectionCache.getCollectionLocation = IkeTransformer.create(function (revision) {
        var collection = store_1.AppStore.Collection.get(revision);
        if (collection == null) {
            return null;
        }
        // trace();
        return collection.location;
    }, { name: 'getCollectionLocation' });
    return PointCollectionCache;
}());
exports.PointCollectionCache = PointCollectionCache;
//# sourceMappingURL=point.collection.cache.js.map